import { IAppDetails } from "./abstractions";

export const EmptyAppDetails: IAppDetails = {
  appId: '',
  shortName: '',
  longName: '',
  shortDescription: '',
  longDescription: '',
  developerName: '',
  version: '',
  websiteUrl: '',
  privacyUrl: '',
  termsOfUseUrl: '',
  mpnId: '',
  webApplicationInfoId: ''
};
